export interface PushNotification {
  id: number;
  type: "live_started" | "new_event" | "new_video" | "cabina_reply" | "contest_active" | "program_starting" | "cabina_message" | "stream_down" | "storage_full" | "new_request" | "abuse_report";
  title: string;
  message: string;
  timestamp: string;
  isRead: boolean;
  role: "listener" | "admin";
  stationName: string | null;
  stationLogo: string | null;
  actionUrl: string;
  priority: "normal" | "high" | "urgent";
}

export const listenerNotifications: PushNotification[] = [
  {
    id: 1,
    type: "live_started",
    title: "¡La Mexicana FM inició live!",
    message: "Alejandro Ramírez comenzó 'El Sabor del Mediodía'. Conéctate y participa en vivo.",
    timestamp: "2026-06-08T12:00:00",
    isRead: false,
    role: "listener",
    stationName: "La Mexicana FM",
    stationLogo: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors%2C%20clean%20modern%20broadcast%20style%2C%20festive%20vibrant%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=notif-logo-3&orientation=squarish",
    actionUrl: "/radio/la-mexicana-fm",
    priority: "normal",
  },
  {
    id: 2,
    type: "new_event",
    title: "Nuevo evento: Summer Fest 2026",
    message: "Radio Nueva Actitud organiza el Summer Fest 2026. Entradas limitadas, reserva tu lugar.",
    timestamp: "2026-06-08T10:30:00",
    isRead: false,
    role: "listener",
    stationName: "Radio Nueva Actitud",
    stationLogo: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20radio%20station%20logo%20design%20with%20musical%20notes%20and%20frequency%20waves%2C%20clean%20circular%20emblem%20style%2C%20warm%20golden%20and%20white%20color%20palette%2C%20simple%20geometric%20shapes%2C%20professional%20broadcast%20aesthetic%2C%20isolated%20on%20transparent%20background%2C%20high%20contrast%20vector%20style&width=200&height=200&seq=notif-logo-1&orientation=squarish",
    actionUrl: "/radio/radio-nueva-actitud",
    priority: "normal",
  },
  {
    id: 3,
    type: "new_video",
    title: "Video nuevo: Entrevista exclusiva",
    message: "Rock Total Radio publicó la entrevista completa con la banda invitada de anoche. ¡Mírala ya!",
    timestamp: "2026-06-07T18:00:00",
    isRead: false,
    role: "listener",
    stationName: "Rock Total Radio",
    stationLogo: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme%2C%20modern%20rock%20broadcast%20emblem%2C%20energetic%20and%20bold%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=notif-logo-5&orientation=squarish",
    actionUrl: "/radio/rock-total-radio",
    priority: "normal",
  },
  {
    id: 4,
    type: "cabina_reply",
    title: "Tu mensaje fue leído al aire",
    message: "La Mexicana FM respondió a tu saludo: '¡Saludos a toda tu familia, Marco! Gracias por acompañarnos desde la obra. ¡Arriba Houston!'",
    timestamp: "2026-06-08T12:15:00",
    isRead: true,
    role: "listener",
    stationName: "La Mexicana FM",
    stationLogo: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors%2C%20clean%20modern%20broadcast%20style%2C%20festive%20vibrant%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=notif-logo-3b&orientation=squarish",
    actionUrl: "/listener",
    priority: "high",
  },
  {
    id: 5,
    type: "contest_active",
    title: "Concurso activo: Trivia Musical",
    message: "Deportes Total Radio lanzó una trivia. Participa y gana entradas para la final de campeones.",
    timestamp: "2026-06-07T14:00:00",
    isRead: true,
    role: "listener",
    stationName: "Deportes Total Radio",
    stationLogo: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20with%20soccer%20ball%20and%20trophy%20icon%2C%20circular%20design%20dark%20blue%20and%20gold%20color%20scheme%2C%20dynamic%20broadcast%20emblem%2C%20energetic%20sports%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=notif-logo-7&orientation=squarish",
    actionUrl: "/radio/deportes-total-radio",
    priority: "high",
  },
  {
    id: 6,
    type: "program_starting",
    title: "Programa por comenzar: La Mesa Redonda",
    message: "En 15 minutos comienza 'La Mesa Redonda' en Deportes Total Radio. Análisis de la jornada.",
    timestamp: "2026-06-07T11:45:00",
    isRead: true,
    role: "listener",
    stationName: "Deportes Total Radio",
    stationLogo: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20with%20soccer%20ball%20and%20trophy%20icon%2C%20circular%20design%20dark%20blue%20and%20gold%20color%20scheme%2C%20dynamic%20broadcast%20emblem%2C%20energetic%20sports%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=notif-logo-7b&orientation=squarish",
    actionUrl: "/radio/deportes-total-radio",
    priority: "normal",
  },
  {
    id: 7,
    type: "live_started",
    title: "¡Banda Radio MX está en vivo!",
    message: "Acaban de arrancar 'Tardes de Banda' con los mejores éxitos regionales mexicanos.",
    timestamp: "2026-06-06T15:00:00",
    isRead: true,
    role: "listener",
    stationName: "Banda Radio MX",
    stationLogo: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20radio%20station%20logo%20with%20trumpet%20and%20accordion%2C%20circular%20design%20red%20white%20and%20green%20colors%2C%20festive%20broadcast%20emblem%2C%20traditional%20Mexican%20vibe%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=notif-logo-12&orientation=squarish",
    actionUrl: "/radio/banda-radio-mx",
    priority: "normal",
  },
  {
    id: 8,
    type: "new_event",
    title: "Noche de Oración y Alabanza",
    message: "Radio Fe y Esperanza te invita a la Noche de Oración este viernes a las 7 PM. Entrada libre.",
    timestamp: "2026-06-05T09:00:00",
    isRead: true,
    role: "listener",
    stationName: "Radio Fe y Esperanza",
    stationLogo: "https://readdy.ai/api/search-image?query=Christian%20radio%20station%20logo%20with%20dove%20symbol%2C%20circular%20minimalist%20design%2C%20soft%20warm%20colors%20white%20and%20gentle%20golden%20tones%2C%20clean%20modern%20broadcast%20emblem%2C%20spiritual%20community%20radio%2C%20isolated%20on%20transparent%20background%2C%20vector%20style%20flat%20design&width=200&height=200&seq=notif-logo-2&orientation=squarish",
    actionUrl: "/radio/radio-fe-y-esperanza",
    priority: "normal",
  },
  {
    id: 9,
    type: "cabina_reply",
    title: "Radio Fe y Esperanza te respondió",
    message: "El Pastor Daniel contestó tu mensaje: 'Amén, Marco. Dios te bendiga abundantemente. Gracias por compartir.'",
    timestamp: "2026-06-06T09:15:00",
    isRead: true,
    role: "listener",
    stationName: "Radio Fe y Esperanza",
    stationLogo: "https://readdy.ai/api/search-image?query=Christian%20radio%20station%20logo%20with%20dove%20symbol%2C%20circular%20minimalist%20design%2C%20soft%20warm%20colors%20white%20and%20gentle%20golden%20tones%2C%20clean%20modern%20broadcast%20emblem%2C%20spiritual%20community%20radio%2C%20isolated%20on%20transparent%20background%2C%20vector%20style%20flat%20design&width=200&height=200&seq=notif-logo-2b&orientation=squarish",
    actionUrl: "/listener",
    priority: "high",
  },
  {
    id: 10,
    type: "contest_active",
    title: "Concurso de Canto: Últimos días",
    message: "La Kalle 99.9 cierra su concurso de canto este domingo. Envía tu audio antes del sábado.",
    timestamp: "2026-06-05T16:00:00",
    isRead: true,
    role: "listener",
    stationName: "La Kalle 99.9",
    stationLogo: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20logo%20with%20headphones%20and%20music%20equalizer%20bars%2C%20circular%20design%20vibrant%20pink%20and%20coral%20colors%2C%20modern%20youthful%20broadcast%20emblem%2C%20energetic%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=notif-logo-9&orientation=squarish",
    actionUrl: "/radio/la-kalle-99-9",
    priority: "high",
  },
  {
    id: 11,
    type: "program_starting",
    title: "Comienza 'Rock Total en Vivo'",
    message: "En 10 minutos arranca el programa estelar de Rock Total Radio. Invitado sorpresa esta noche.",
    timestamp: "2026-06-04T19:50:00",
    isRead: true,
    role: "listener",
    stationName: "Rock Total Radio",
    stationLogo: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme%2C%20modern%20rock%20broadcast%20emblem%2C%20energetic%20and%20bold%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=notif-logo-5b&orientation=squarish",
    actionUrl: "/radio/rock-total-radio",
    priority: "normal",
  },
  {
    id: 12,
    type: "new_video",
    title: "Nuevo video: Cobertura especial",
    message: "Radio Vida Nueva subió el video de la cobertura del evento benéfico del fin de semana.",
    timestamp: "2026-06-03T11:00:00",
    isRead: true,
    role: "listener",
    stationName: "Radio Vida Nueva",
    stationLogo: "https://readdy.ai/api/search-image?query=Christian%20worship%20radio%20station%20logo%20with%20cross%20and%20sunrise%20symbols%2C%20circular%20design%20soft%20blue%20and%20white%20colors%2C%20peaceful%20spiritual%20broadcast%20emblem%2C%20minimalist%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=notif-logo-11&orientation=squarish",
    actionUrl: "/radio/radio-vida-nueva",
    priority: "normal",
  },
];

export const adminNotifications: PushNotification[] = [
  {
    id: 101,
    type: "cabina_message",
    title: "Nuevo mensaje en Cabina",
    message: "María López envió un saludo: 'Buenos días a todos, los escucho desde Dallas. ¡Bendiciones!'",
    timestamp: "2026-06-08T12:05:00",
    isRead: false,
    role: "admin",
    stationName: null,
    stationLogo: null,
    actionUrl: "/admin/cabina",
    priority: "normal",
  },
  {
    id: 102,
    type: "cabina_message",
    title: "Nuevo mensaje en Cabina (urgente)",
    message: "Carlos Vega reporta: 'Hay una emergencia en la zona norte, necesitan comunicado urgente al aire.'",
    timestamp: "2026-06-08T12:10:00",
    isRead: false,
    role: "admin",
    stationName: null,
    stationLogo: null,
    actionUrl: "/admin/cabina",
    priority: "urgent",
  },
  {
    id: 103,
    type: "stream_down",
    title: "Alerta: Stream caído",
    message: "La transmisión de La Mexicana FM se interrumpió a las 11:45 AM. Verifica la conexión del encoder.",
    timestamp: "2026-06-08T11:47:00",
    isRead: false,
    role: "admin",
    stationName: "La Mexicana FM",
    stationLogo: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors%2C%20clean%20modern%20broadcast%20style%2C%20festive%20vibrant%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=notif-logo-3c&orientation=squarish",
    actionUrl: "/admin/broadcast-center",
    priority: "urgent",
  },
  {
    id: 104,
    type: "storage_full",
    title: "Almacenamiento casi lleno",
    message: "Tu espacio de fotos está al 92%. Quedan 1.2 GB disponibles. Considera liberar espacio o ampliar tu plan.",
    timestamp: "2026-06-07T20:00:00",
    isRead: true,
    role: "admin",
    stationName: null,
    stationLogo: null,
    actionUrl: "/admin/photos",
    priority: "high",
  },
  {
    id: 105,
    type: "new_request",
    title: "Nueva solicitud de colaboración",
    message: "Radio Comunitaria Unida quiere hacer un programa conjunto para el Día de la Independencia. Revisa la propuesta.",
    timestamp: "2026-06-07T15:30:00",
    isRead: true,
    role: "admin",
    stationName: "Radio Comunitaria Unida",
    stationLogo: "https://readdy.ai/api/search-image?query=Community%20radio%20station%20logo%20with%20people%20holding%20hands%20in%20circle%2C%20minimalist%20design%20with%20warm%20earth%20tones%2C%20green%20and%20orange%20colors%2C%20inclusive%20broadcast%20emblem%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=notif-logo-6&orientation=squarish",
    actionUrl: "/admin/dashboard",
    priority: "normal",
  },
  {
    id: 106,
    type: "abuse_report",
    title: "Reporte de abuso",
    message: "Usuario 'dj_falso_99' fue reportado por spam repetitivo en la Cabina. 3 oyentes lo marcaron en la última hora.",
    timestamp: "2026-06-07T14:00:00",
    isRead: false,
    role: "admin",
    stationName: null,
    stationLogo: null,
    actionUrl: "/admin/cabina/moderacion",
    priority: "high",
  },
  {
    id: 107,
    type: "storage_full",
    title: "Almacenamiento de videos al 85%",
    message: "Tus videos ocupan 7.8 GB de 9 GB disponibles. Recomendamos comprimir archivos antiguos.",
    timestamp: "2026-06-06T18:00:00",
    isRead: true,
    role: "admin",
    stationName: null,
    stationLogo: null,
    actionUrl: "/admin/videos",
    priority: "normal",
  },
  {
    id: 108,
    type: "stream_down",
    title: "Stream inestable detectado",
    message: "Rock Total Radio tuvo 3 micro-cortes en la última hora. Latencia promedio: 450ms. Revisa tu conexión.",
    timestamp: "2026-06-06T22:15:00",
    isRead: true,
    role: "admin",
    stationName: "Rock Total Radio",
    stationLogo: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme%2C%20modern%20rock%20broadcast%20emblem%2C%20energetic%20and%20bold%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=notif-logo-5c&orientation=squarish",
    actionUrl: "/admin/broadcast-center",
    priority: "high",
  },
  {
    id: 109,
    type: "new_request",
    title: "Solicitud de auspicio",
    message: "Empresa 'Sonido Total' quiere pautar publicidad en tu radio. Presupuesto mensual: $1,200 USD.",
    timestamp: "2026-06-05T10:00:00",
    isRead: true,
    role: "admin",
    stationName: null,
    stationLogo: null,
    actionUrl: "/admin/dashboard",
    priority: "high",
  },
  {
    id: 110,
    type: "abuse_report",
    title: "Reporte de contenido inapropiado",
    message: "Un mensaje con lenguaje ofensivo fue detectado y bloqueado automáticamente. Revisar en moderación.",
    timestamp: "2026-06-04T16:45:00",
    isRead: true,
    role: "admin",
    stationName: null,
    stationLogo: null,
    actionUrl: "/admin/cabina/moderacion",
    priority: "high",
  },
];

export const allNotifications: PushNotification[] = [
  ...listenerNotifications,
  ...adminNotifications,
];

export interface NotificationPreference {
  id: string;
  label: string;
  description: string;
  icon: string;
  role: "listener" | "admin" | "both";
  type: PushNotification["type"] | "all";
  enabled: boolean;
}

export const notificationPreferences: NotificationPreference[] = [
  {
    id: "pref-live-started",
    label: "Radio inició live",
    description: "Cuando una de tus radios favoritas comienza a transmitir en vivo",
    icon: "ri-broadcast-line",
    role: "listener",
    type: "live_started",
    enabled: true,
  },
  {
    id: "pref-new-event",
    label: "Nuevo evento",
    description: "Cuando se publica un evento nuevo de tus radios seguidas",
    icon: "ri-calendar-event-line",
    role: "listener",
    type: "new_event",
    enabled: true,
  },
  {
    id: "pref-new-video",
    label: "Nuevo video",
    description: "Cuando una radio que sigues sube un video nuevo",
    icon: "ri-video-line",
    role: "listener",
    type: "new_video",
    enabled: true,
  },
  {
    id: "pref-cabina-reply",
    label: "Respuesta de Cabina",
    description: "Cuando un locutor lee tu mensaje al aire o te responde",
    icon: "ri-message-2-line",
    role: "listener",
    type: "cabina_reply",
    enabled: true,
  },
  {
    id: "pref-contest-active",
    label: "Concurso activo",
    description: "Cuando se activa un concurso en el que puedes participar",
    icon: "ri-trophy-line",
    role: "listener",
    type: "contest_active",
    enabled: true,
  },
  {
    id: "pref-program-starting",
    label: "Programa por comenzar",
    description: "Recordatorio cuando un programa está por iniciar",
    icon: "ri-timer-line",
    role: "listener",
    type: "program_starting",
    enabled: true,
  },
  {
    id: "pref-cabina-message",
    label: "Nuevo mensaje en Cabina",
    description: "Cuando un oyente envía un mensaje a tu cabina",
    icon: "ri-chat-3-line",
    role: "admin",
    type: "cabina_message",
    enabled: true,
  },
  {
    id: "pref-stream-down",
    label: "Stream caído",
    description: "Alerta cuando tu transmisión se interrumpe o tiene problemas",
    icon: "ri-alert-line",
    role: "admin",
    type: "stream_down",
    enabled: true,
  },
  {
    id: "pref-storage-full",
    label: "Storage casi lleno",
    description: "Cuando el almacenamiento de fotos o videos está por agotarse",
    icon: "ri-hard-drive-2-line",
    role: "admin",
    type: "storage_full",
    enabled: true,
  },
  {
    id: "pref-new-request",
    label: "Nueva solicitud",
    description: "Cuando recibes una solicitud de colaboración o auspicio",
    icon: "ri-mail-line",
    role: "admin",
    type: "new_request",
    enabled: true,
  },
  {
    id: "pref-abuse-report",
    label: "Reporte de abuso",
    description: "Cuando se detecta o reporta contenido inapropiado",
    icon: "ri-shield-line",
    role: "admin",
    type: "abuse_report",
    enabled: true,
  },
];

export interface PushPermission {
  id: string;
  label: string;
  description: string;
  icon: string;
  granted: boolean;
  required: boolean;
}

export const pushPermissions: PushPermission[] = [
  {
    id: "perm-push",
    label: "Notificaciones Push",
    description: "Recibe notificaciones incluso cuando no estás usando la app",
    icon: "ri-notification-3-line",
    granted: true,
    required: true,
  },
  {
    id: "perm-sound",
    label: "Sonido",
    description: "Reproducir sonido al recibir notificaciones",
    icon: "ri-volume-up-line",
    granted: true,
    required: false,
  },
  {
    id: "perm-vibration",
    label: "Vibración",
    description: "Vibrar al recibir notificaciones en dispositivos móviles",
    icon: "ri-smartphone-line",
    granted: true,
    required: false,
  },
  {
    id: "perm-badge",
    label: "Insignia en ícono",
    description: "Mostrar contador de notificaciones no leídas en el ícono de la app",
    icon: "ri-apps-2-line",
    granted: false,
    required: false,
  },
  {
    id: "perm-lockscreen",
    label: "Pantalla de bloqueo",
    description: "Mostrar notificaciones en la pantalla de bloqueo del dispositivo",
    icon: "ri-lock-line",
    granted: true,
    required: false,
  },
  {
    id: "perm-banner",
    label: "Banners",
    description: "Mostrar notificaciones como banners temporales en pantalla",
    icon: "ri-layout-top-line",
    granted: true,
    required: false,
  },
];

export const notificationTypeLabels: Record<PushNotification["type"], string> = {
  live_started: "Radio inició live",
  new_event: "Nuevo evento",
  new_video: "Nuevo video",
  cabina_reply: "Respuesta de Cabina",
  contest_active: "Concurso activo",
  program_starting: "Programa por comenzar",
  cabina_message: "Nuevo mensaje Cabina",
  stream_down: "Stream caído",
  storage_full: "Storage casi lleno",
  new_request: "Nueva solicitud",
  abuse_report: "Reporte de abuso",
};

export const notificationTypeIcons: Record<PushNotification["type"], string> = {
  live_started: "ri-broadcast-line",
  new_event: "ri-calendar-event-line",
  new_video: "ri-video-line",
  cabina_reply: "ri-message-2-line",
  contest_active: "ri-trophy-line",
  program_starting: "ri-timer-line",
  cabina_message: "ri-chat-3-line",
  stream_down: "ri-alert-line",
  storage_full: "ri-hard-drive-2-line",
  new_request: "ri-mail-line",
  abuse_report: "ri-shield-line",
};

export const priorityColors: Record<PushNotification["priority"], string> = {
  normal: "bg-foreground-100 text-foreground-600",
  high: "bg-accent-100 text-accent-700",
  urgent: "bg-red-100 text-red-700",
};

export const notificationFilters = [
  { id: "all", label: "Todas", icon: "ri-notification-3-line" },
  { id: "unread", label: "No leídas", icon: "ri-mail-unread-line" },
  { id: "listener", label: "Oyente", icon: "ri-user-line" },
  { id: "admin", label: "Admin", icon: "ri-shield-user-line" },
] as const;

export type NotificationFilterId = (typeof notificationFilters)[number]["id"];